$(document).ready(function () {
    initDevicePanel();
    initDeviceKeys();
    initDeviceRequestForm();
    initDeviceImages();

    initDeviceOrdersChart();
    initDeviceLoadPie();
    initDeviceLoadColumns()
    initDeviceOrdersPlacedChart();
    initDeviceOnlineStatView();

    $.ajaxSetup({
        beforeSend: function(xhr, settings) {
        var csrf_token = document.getElementsByName("csrfmiddlewaretoken")[0].value;
        xhr.setRequestHeader("X-CSRFToken", csrf_token);}
    });

    $('#delete_photos').on('click', function () {
        let data = $('input[name="gallery"]:checked').serialize();
        $.ajax({
            type: 'POST',
            url: $(this).data('url'),
            data: data,
            success: function (response) {
                showNoty('success', response.message);
                setTimeout(function() {
                     location.reload(true);
                 }, 3000);
            },
            error: function (response) {
                showNoty('error', response.responseJSON.message);
            }
        });
    })
    $('#make_photo').on('click', function () {
        $.ajax({
            type: 'POST',
            url: $(this).data('url'),
            success: function (response) {
                showNoty('success', response.message);
                setTimeout(function() {
                     location.reload(true);
                 }, 3000);
            },
            error: function (response) {
                showNoty('error', response.responseJSON.message);
            }
        });
    })
});

function initDeviceLoadPie(device_uid_param = null) {
    let block = $('[data-dashboard="device-load-pie"]');
    if (block.length === 0) {
        return;
    }

    let device_uid;
    if (device_uid_param === null) {
        device_uid = $('[data-device-uid]').data('device-uid');
    } else {
        device_uid = device_uid_param;
    }

    if (!device_uid) {
        return;
    }

    let url = '/api/2.0.0/dashboard/device/' + device_uid + '/load/stat/';
    sendApiGet(url, function (response) {
        let data = response.data;

        let series = [{
            colorByPoint: true,
            data: [{
                name: _('Occupied'),
                count: data.occupied,
                y: parseFloat(((data.occupied / data.active) * 100).toFixed(2))
            }, {
                name: _('Blocked'),
                count: data.locked,
                y: parseFloat(((data.locked / data.active) * 100).toFixed(2))
            }, {
                name: _('Free'),
                count: data.free,
                y: parseFloat(((data.free / data.active) * 100).toFixed(2))
            }]
        }];

        Highcharts.chart('device-load-pie', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: null,
            tooltip: {
                pointFormat: '<b>{point.count}</b> ({point.percentage:.1f}%)'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                itemMarginTop: 3,
                itemMarginBottom: 3
            },
            plotOptions: {
                pie: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true
                }
            },
            series: series
        });
    });
}

function initDeviceLoadColumns(device_uid_param = null) {
    const block = $('[data-dashboard="device-load-columns"]');
    if (block.length === 0) {
        return;
    }

    let device;
    if (device_uid_param === null) {
        device = $('[data-device-uid]').data('device');
    } else {
        device = device_uid_param;
    }

    if (!device) {
        device = '';
    }

    let dashboardNetworkFilter = $("#dashboard-network-filter").val();

    let url = '/api/2.0.0/dashboard/orders/count/per-days-of-week/?device=' + device;
    if (typeof dashboardNetworkFilter === 'string' && dashboardNetworkFilter.length !== 0) {
        url = url + '&net=' + dashboardNetworkFilter;
    }

    sendApiGet(url, function (response) {
        const data = response.data;
        const reducer = (previousValue, currentValue) => previousValue + currentValue;
        const counts = Object.values(data)
        const limitCount = Math.round(counts.reduce(reducer) / counts.length)
        console.log('Limit Count: ' + limitCount)
        let dataToShow = []
        counts.forEach(function (count) {
            let element = {'y': count, 'color': '#45aaf2'}
            if (count > limitCount) {
                element['color'] = '#fd7e14'
            }
            dataToShow.push(element)
        })

        Highcharts.chart('device-load-columns', {
            title: {
                text: ''
            },
            xAxis: {
                categories: Object.keys(data)
            },
            yAxis: {
                title: {
                    text: ''
                },
                visible: false
            },
            series: [{
                type: 'column',
                name: '',
                data: dataToShow,
                showInLegend: false
            }]
        });
    });
}


function initDeviceOrdersChart() {
    let block = $('[data-dashboard="device-orders-chart"]');
    if (block.length === 0) {
        return;
    }

    let device = $('[data-device]').data('device');
    let url = '/api/2.0.0/dashboard/devices/orders/period/stat/' + '?device=' + device;
    let timezone = "UTC";
    sendApiGet(url, function (response) {
        let series_reserved = [];
        let series_placed = [];
        let series_receipt = [];
        let series_prepared = [];
        let series_extracted = [];
        let series_canceled = [];
        let series_processed = [];

        let series = [];
        if (block.attr('data-franchisee')) {
            response.data.forEach(function (data, index, array) {
                let date = Date.parse(data.date);
                if (index === array.length - 1) {
                    date = getCurrentDateWithoutSecondsAndMilliseconds();
                }
                series_placed.push([date, data.placed]);
                series_processed.push([date, data.processed]);
                timezone = data.tz;
            });

            series = [{
                name: _('Placed'),
                data: series_placed,
                type: 'areaspline',
                fillColor: hcFillColor(0)
            }, {
                name: _('Processed'),
                data: series_processed,
                type: 'areaspline',
                fillColor: hcFillColor(1)
            }];
        } else {
            response.data.forEach(function (data, index, array) {
                let date = Date.parse(data.date);
                if (index === array.length - 1) {
                    date = getCurrentDateWithoutSecondsAndMilliseconds();
                }
                series_reserved.push([date, data.reserved]);
                series_placed.push([date, data.placed]);
                series_receipt.push([date, data.receipt]);
                series_prepared.push([date, data.prepared_to_withdrawn]);
                series_extracted.push([date, data.extracted]);
                series_canceled.push([date, data.canceled]);
                timezone = data.tz;
            });
            series = [{
                name: _('Reserved'),
                data: series_reserved,
                type: 'areaspline',
                fillColor: hcFillColor(0)
            }, {
                name: _('Placed'),
                data: series_placed,
                type: 'areaspline',
                fillColor: hcFillColor(1)
            }, {
                name: _('Received'),
                data: series_receipt,
                type: 'areaspline',
                fillColor: hcFillColor(2)
            }, {
                name: _('To withdrawal'),
                data: series_prepared,
                type: 'areaspline',
                fillColor: hcFillColor(3)
            }, {
                name: _('Withdrawn'),
                data: series_extracted,
                type: 'areaspline',
                fillColor: hcFillColor(4)
            }, {
                name: _('Canceled'),
                data: series_canceled,
                type: 'areaspline',
                fillColor: hcFillColor(5)
            }];
        }
        console.log('Timezone:', timezone);
        Highcharts.stockChart('orders-chart', {
            rangeSelector: {
                enabled: false
            },
            navigator: {
                xAxis: {
                    tickInterval:true,
                    labels: {
                        align: 'center'
                    },
                }
            },
            title: null,
            series: series,
            time: {
                useUTC: false,
                timezone: timezone,
            },
        });
    });
}

function initDeviceOrdersPlacedChart(period=null) {
    let block = $('[data-dashboard="device-orders-placed-chart"]');
    if (block.length === 0) {
        return;
    }

    let device_uid = $('[data-device-uid]').data('device-uid');

    if (!device_uid) {
        return;
    }

    let url = '/api/2.0.0/dashboard/device/' + device_uid + '/orders/placed/';
    url += (period === null) ? '' : '?period=all_time'
    let timezone = "UTC";
    sendApiGet(url, function (response) {
        let series_placed = [];
        let avg_series_placed = [];
        let data = response.data;
        let objects_count = data.length;
        let placed_sum = data.reduce(function (acc, curr) {
            return {
                date: curr.date,
                placed: acc.placed + curr.placed
            }
        });
        data.forEach(function (data, index, array) {
            let date = Date.parse(data.date);
            if (index === array.length - 1) {
                date = getCurrentDateWithoutSecondsAndMilliseconds();
            }
            series_placed.push([date, data.placed]);
            avg_series_placed.push([date, placed_sum.placed / objects_count]);
            timezone = data.tz;
        });
        console.log('Timezone:', timezone);
        let series = [{
            name: _('Workload'),
            data: series_placed,
            type: 'areaspline',
            fillColor: hcFillColor(0)
        }, {
            name: _('Avg. Workload'),
            data: avg_series_placed,
            type: 'areaspline',
            fillColor: hcFillColor(0)
        }];

        Highcharts.stockChart('device-orders-placed-chart', {
            colors: ['#3867d6', '#dc3545'],
            rangeSelector: {
                enabled: false
            },
            navigator: {
                xAxis: {
                    tickInterval:true,
                    labels: {
                        align: 'center'
                    },
                }
            },
            title: null,
            tooltip: {
                valueSuffix: '%',
                valueDecimals: 4
            },
            series: series,
            time: {
                useUTC: false,
                timezone: timezone,
            },
        });
    });
}

function initDeviceOnlineStatView(period=null) {
    let block = $('[data-dashboard="device-online-offline-statistics"]');
    if (block.length === 0) {
        return;
    }

    let device_uid = $('[data-device-uid]').data('device-uid');

    if (!device_uid) {
        return;
    }

    let url = '/api/2.0.0/dashboard/device/' + device_uid + '/online/stat/';
    url += (period === null) ? '' : '?period=' + period
    let timezone = "UTC";
    sendApiGet(url, function (response) {
        let series_diagram = [];
        let data = response.data;

        data.forEach(function (data) {
            let date = Date.parse(data.date);
            let y;
            if (data.status === 1) {
                y = 1; // Online
            } else if (data.status === 2) {
                y = 0.5; // Sleep
            } else {
                y = 0; // Offline
            }
            series_diagram.push([date, y]);
            timezone = data.tz;
        });
        let series = [{
            name: _('Device status'),
            data: series_diagram,
            // type: 'areaspline',
            type: 'area',
            step: true,
            fillColor: hcFillColor(4),
        }];
        console.log('Timezone:', timezone);
        Highcharts.stockChart('device-online-offline-statistics', {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                zoomType: 'x'
            },
            navigator: {
                enabled: false
            },
            tooltip: {
                formatter: function () {
                // let device_status = this.y >= 1 ? "Online" : "Offline"
                let device_status;
                if (this.y === 1) {
                    device_status = "Online";
                } else if (this.y === 0) {
                    device_status = "Offline";
                } else if (this.y === 0.5) {
                    device_status = "Sleep";
                }
                let timestamp = new Date(this.x);
                let time_options = {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                };
                let devicedatetime = timestamp.toLocaleDateString('en-GB', time_options);
                    return 'Device status: <b>' + device_status +',  '+ devicedatetime + '</b><br/>';
                }
            },
            colors: ['#3867d6', '#dc3545', '#ffc107'],
            rangeSelector: {
                enabled: false
            },
            series: series,
            time: {
                  useUTC: false,
                  timezone: timezone,
            },
            xAxis: {
                type: 'datetime',
                 ordinal:false,
            },
             yAxis: {
                categories: ['', ''],
                max:1,
                 min: 0,
                minPadding: 0,
                maxPadding: 1,
                plotLines: [{
                    color: '#0bd70e',
                    value: 0.95,
                    width: 4,
                    label: {
                        fontSize: '20px',
                        text: _('ONLINE'),
                        y: -12,
                    style: {
                        fontWeight: 'bold',
                        fontSize: '15px',
                    }}},
                    {
                        color: '#ffc107',
                        value: 0.5,
                        width: 4,
                        label: {
                            text: _('SLEEP'),
                            align: 'left',
                            y: -12,
                            style: {
                                fontWeight: 'bold',
                                fontSize: '15px',
                            }
                        }
                    },
                {
                    color: '#bb0808',
                    value: 0.05,
                    width: 6,
                    label: {
                        text: _('OFFLINE'),
                        align: 'left',
                        verticalAlign: 'top',
                        y: 28,
                        style: {
                        fontWeight: 'bold',
                        fontSize: '15px',
                    }}},],},
        });
    });
}

function initDeviceImages() {
    let block = $('.device-panel-images');
    if (block.length === 0) {
        return;
    }

    $('[data-fancybox="device-gallery"]').fancybox({
        loop: true,
        infobar: false,
        toolbar: false
    });
}


function initDeviceKeys() {
    let block = $('.device-keys-table');
    if (block.length === 0) {
        return;
    }

    block
        .on('click', '[data-action-generate]', function () {
            let btn = $(this);
            let serial_block = $(this).closest('[data-device-serial]');
            let key_block = $('[data-device-key]', serial_block);

            confirmModal($(this), function () {
                let url = '/devices/keys/';
                let data = {
                    serial: serial_block.data('device-serial'),
                    csrfmiddlewaretoken: $('input[name="csrfmiddlewaretoken"]').prop('value')
                };
                btn.prop('disabled', true);
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: data,
                    success: function (response) {
                        showNoty('success', gettext('Updated'));
                    },
                    error: function (response) {
                        showNoty('error', response.responseJSON.message);
                    }
                });
            });
        })
    ;
}

function initDevicePanel() {
    initDeviceSelect();
    updateDeviceMapView();

    let block = $('[data-device-panel]');

    if (block.length === 0) {
        return;
    }

    let block_active = $('.active[data-device-panel]');
    block_active
        .on('click', '[data-cell]', function () {
            $(this).toggleClass('active');
        })
        .on('click', '[data-action]', function () {
            let action = $(this).data('action');

            if (action === 'set-numbers') {
                setDeviceCellsNumbers();
            } else if (action === 'check-all') {
                $('[data-cell]').addClass('active');
            } else if (action === 'uncheck-all') {
                $('[data-cell]').removeClass('active');
            } else if (action === 'reload') {
                devicePanelUpdateBlock($(this));
            }
        })
        .on('click', '[data-cell-action]', function () {
            let data = {
                action: $(this).data('cell-action'),
                items: []
            };
            $('.active[data-cell]').each(function () {
                data['items'].push($(this).data('cell'));
            });
            if (data.action === 'lock') {
                data['locked_reason'] = 50}

            if (data['items'].length === 0) {
                showNoty('warning', gettext('Select cells'));
                return false;
            }

            confirmModal($(this), function () {
                sendCommand('/devices/command/cell/', data);
                disableCells($('.active[data-cell]'));
                devicePanelUpdateBlock($(this));
            });
        })
        .on('click', '[data-controller-action]', function () {
            let controller_block = $(this).closest('[data-controller]');
            let controller_id = $('[data-controller-id]', controller_block).data('controller-id');
            let data = {
                action: $(this).data('controller-action'),
                items: [controller_block.data('controller')]
            };

            confirmModal($(this), function () {
                sendCommand('/devices/command/controller/', data);
                if (data.action === 'openall') {
                    disableCells($('[data-cell-controller="' + controller_id + '"]'));
                }
                devicePanelUpdateBlock($(this));
            });
        })
        .on('click', '[data-device-action]', function () {
            let device_block = $('[data-device]');
            let data = {
                action: $(this).data('device-action'),
                items: [device_block.data('device')]
            };

            confirmModal($(this), function () {
                sendCommand('/devices/command/device/', data);
                if (data.action === 'openall') {
                    disableCells($('[data-cell]'));
                }
            });
        })
        .on('click', '[data-sys-action]', function () {
            let device_block = $('[data-device]');
            let data = {
                action: $(this).data('sys-action'),
                device: device_block.data('device')
            };

            confirmModal($(this), function () {
                sendCommand('/devices/sys-command/', data);
            });
        })
        .on('mouseenter', '[data-controller-id]', function () {
            let controller = $(this).data('controller-id');
            $('[data-cell-controller="' + controller + '"]').addClass('highlight');
        })
        .on('mouseleave', '[data-controller-id]', function () {
            let controller = $(this).data('controller-id');
            $('[data-cell-controller="' + controller + '"]').removeClass('highlight');
        })
        .on('click', '[data-switch-action]', function () {
            let device_block = $('[data-device]');
            let data = {
                action: $(this).data('switch-action'),
                items: [device_block.data('device')]
            };

            confirmModal($(this), function () {
                sendCommand('/devices/command/switch/', data);
            });
        })
    ;

    initDevicePanelUpdate();
}

function initDeviceSelect() {
    $('#deviceSelect')
        .on('change', function () {
            document.location = $(this).val();
        })
        .select2({
            placeholder: 'Choose one',
            searchInputPlaceholder: 'Search options',
            minimumInputLength: 1
        })
    ;
}

function disableCells(cells) {
    cells.removeClass('active').prop('disabled', true);
}

function initDevicePanelUpdate() {
    setTimeout(function () {
        devicePanelUpdate(true);
    }, 5000)
}

function devicePanelUpdate(set_timeout) {
    let block = $('[data-device]');
    if (block.length === 0) {
        return false;
    }

    if (set_timeout === undefined) {
        set_timeout = false;
    }

    let url = '/devices/' + block.data('device') + '/panel/update/';
    let data = {
        csrfmiddlewaretoken: $('input[name="csrfmiddlewaretoken"]').prop('value')
    };
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (response) {
            let info = response.data.info;
            let device_status_block = $('[data-device-status]');
            if (device_status_block.prop('data-device-status') !== info.status) {
                device_status_block
                    .prop('data-device-status', info.status)
                    .removeClass('text-success text-light')
                    .addClass(info.ico);
            }

            $('[data-device-orders-sync-date]').text(info.orders_sync_date);
            $('[data-device-orders-sync-ico]').removeClass('text-success text-light').addClass(info.orders_sync_ico);
            $('[data-device-orders-sync-count]').text('[' + info.orders_sync_count + ']');

            info.stacks.forEach(function (stack) {
                stack.controllers.forEach(function (controller) {
                    let controller_block = $('[data-controller="' + controller.key + '"]');
                    let controller_status_block = $('[data-controller-status]', controller_block);
                    if (controller_status_block.prop('data-controller-status') !== controller.status) {
                        controller_status_block
                            .prop('data-controller-status', controller.status)
                            .attr('title', controller.tooltip)
                            .removeClass('text-success text-light')
                            .addClass(controller.ico);
                    }
                    let controller_version_block = $('[data-controller-version]', controller_block);
                    if (controller_version_block.prop('data-controller-version') !== controller.version) {
                        controller_version_block
                            .prop('data-controller-version', controller.version)
                            .text(controller.version);
                    }
                });

                stack.cells.forEach(function (col) {
                    col.forEach(function (row) {
                        row.forEach(function (cell) {

                            let cell_block = $('[data-cell="' + cell.key + '"]');

                            if (cell_block.attr('data-cell-code') !== undefined) {

                                if (cell_block.attr('data-cell-code').toString() !== cell.code) {
                                    cell_block.attr('data-cell-code', cell.code);
                                    cell_block
                                    .removeClass('btn-success btn-info btn-danger btn-dark')
                                    .addClass(cell.btn);
                                }

                                let cell_block_icons = $('.device-stack-cell-ico', cell_block);

                                $('[data-toggle="tooltip"]', cell_block_icons).each(function () {
                                    $(this).tooltip('hide');
                                });
                                cell_block_icons.empty();

                                cell.icons.forEach(function (ico) {
                                    let i = $('<i/>').addClass('btn-dark p-1 fas h ' + ico);
                                    if (cell.parcel && cell.parcel.status && ico && ico.includes('box')) {
                                        i.attr('title', cell.parcel.status).attr('data-toggle', 'tooltip');
                                    }
                                    cell_block_icons.append(i);
                                });
                                initTooltip($('[data-toggle="tooltip"]', cell_block_icons));
                            }
                        });
                    });
                });
            });

            if (set_timeout) {
                setTimeout(function () {
                    devicePanelUpdate(true);
                }, 5000)
            }
        }
    });
}

function devicePanelUpdateBlock(btn) {
    let block = $('.device-stack-container');
    if (block.length === 0) {
        return false;
    }

    let url = '/devices/' + $('[data-device]').data('device') + '/panel/update/';
    btn.prop('disabled', true);
    $.ajax({
        type: 'GET',
        url: url,
        success: function (response) {
            btn.prop('disabled', false);
            block.empty().append(response);
            initTooltip($('[data-toggle="tooltip"]', block));
            showNoty('success', gettext('Updated'));
        }
    });
}

function setDeviceCellsNumbers() {
    let url = "/device/cells/numbers/set/";
    let data = {
        device_id: $("[data-device]").data("device"),
        csrfmiddlewaretoken: $('input[name="csrfmiddlewaretoken"]').prop('value')
    };
    $.ajax({
        type: "POST",
        url: url,
        data: data,
        success: function (response) {
            showNoty('success', gettext('Initialized'));
            location.reload(true);
        },
        error: function (response) {
             showNoty('error', 'Status code: ' + response.status);
        }
    });
}

function sendCommand(url, data) {
    data['csrfmiddlewaretoken'] = $('input[name="csrfmiddlewaretoken"]').prop('value');
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (response) {
            showNoty('success', response.message);
        },
        error: function (response) {
            if (response.status === 200) {
                showNoty('error', response.responseJSON.message);
            } else {
                showNoty('error', 'Status code: ' + response.status);
            }
        },
        complete: function () {
            devicePanelUpdate();
        }
    });
}

$(document).ready(function () {
    $('select.search').select2({
        placeholder: '---------',
        allowClear: true,
        searchInputPlaceholder: gettext('Search')
    });
});

function initDeviceRequestForm() {
    $('.btn-request').on('click', function () {
        $('#hidden-request-form').submit();
    })
}

function updateDeviceMapView() {
    // Add scroll if device map do not fit in container
    let block = $('.device-stack-container');
    if (block.data('width') >= block.width()) {
        block.addClass('device-stacks-view')
    } else {
        block.removeClass('device-stacks-view')
    }
}
